import CountiesPage from "../../pages/legacy/counties/CountiesPage";

const route = {
  key: "counties",
  path: "/legacy/counties",
  component: CountiesPage,
  private: true,
  layout: "main",
  icon: "faMapLocationDot",
  group: "masterdata",
  order: 30,
  permission: "legacy.counties.read"
};

export default route;